import { AnyAction } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { concat, debounceTime, distinctUntilChanged, filter, map, Observable, of, switchMap } from 'rxjs';
import { mapPayload } from '../../../../Utils/RxjsOperators/MapPayload';
import { MoonListManager } from '../../../MoonListManager/MoonListManager';
import ComponentStateActions from '../../Global/ComponentState/ComponentStateActions';
import { StoreDependencies } from '../../Global/StoreDependencies';
import { StoreState } from '../../Global/StoreState';
import MoonListsActions from './MoonListsActions';

const componentStatePrefix: string = 'MOON_LISTS';

function getMoonLists(
  $action: Observable<AnyAction>,
  _$state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return $action.pipe(
    filter(MoonListsActions.getMoonLists.match),
    switchMap(() =>
      concat(
        of(ComponentStateActions.setLoading(componentStatePrefix)),
        fetchAllMoonLists(dependencies.moonListManager!),
        fetchPopularMoonLists(dependencies.moonListManager!),
        of(ComponentStateActions.setData(componentStatePrefix))
      )
    )
  );
}

function searchMoonLists(
  $action: Observable<AnyAction>,
  _$state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return $action.pipe(
    filter(MoonListsActions.setSearch.match),
    mapPayload(),
    debounceTime(150),
    distinctUntilChanged(),
    filter((search) => search.length > 0),
    switchMap((search) => dependencies.moonListManager!.searchMoonLists(search)),
    map(MoonListsActions.setSearchResults)
  );
}

function fetchAllMoonLists(moonListsManager: MoonListManager): Observable<AnyAction> {
  return moonListsManager.getMoonLists().pipe(map(MoonListsActions.setAllMoonLists));
}

function fetchPopularMoonLists(moonListsManager: MoonListManager): Observable<AnyAction> {
  return moonListsManager.getPopularMoonLists().pipe(map(MoonListsActions.setPopularMoonLists));
}

export default combineEpics(getMoonLists, searchMoonLists);
